import { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { colors, measurments } from '../utils/config'
import {
  hexToRGBA,
  lightenDarkenColor,
  LucideIconName,
} from '@bm-js/atlascloud-shared'
import { Icon } from '@bm-js/atlascloud-ui'

const StyledPopup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: -50%;
  right: 0;
  background: ${hexToRGBA(lightenDarkenColor(colors.gray500, 0), 0.7)};
  opacity: 0;
  pointer-events: none;
  transition: 400ms ease-in-out;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  .popup-container {
    position: relative;
    border-radius: ${measurments.borderRadiusLarge}px;
    transition: 400ms ease-in-out;
    width: 100%;
    max-width: 1000px;
    max-height: 80vh;
    overflow: scroll;
    background: ${colors.gray200};
    box-shadow:
      0px 12px 16px -4px rgba(16, 24, 40, 0.1),
      0px 4px 6px -2px rgba(16, 24, 40, 0.05);
    padding: 2rem;
  }
  .close-container {
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
  }
  &.active {
    bottom: 0;
    opacity: 1;
    pointer-events: initial;
  }
`

type Props = {
  content: React.ReactNode
  close: () => void
  active: boolean
}

const Popup = ({ content, close, active }: Props) => {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleClickOutside = (e: any) => {
      const tinyMceAux = document.querySelector('.tox-tinymce-aux')
      const tinyMceContainer = document.querySelector('.tox.tox-tinymce')
      const mediaLibraryModalRoot = document.querySelector(
        '#media-library-modal-root'
      )
      const refContainsTarget = ref.current && ref.current.contains(e.target)
      const tinyMceContainerContainsTarget =
        tinyMceContainer && tinyMceContainer.contains(e.target)
      const tinyMceAuxContainsTarget =
        tinyMceAux && tinyMceAux.contains(e.target)
      const mediaLibraryModalRootContainsTarget =
        mediaLibraryModalRoot && mediaLibraryModalRoot.contains(e.target)

      if (
        !refContainsTarget &&
        !tinyMceAuxContainsTarget &&
        !tinyMceContainerContainsTarget &&
        !mediaLibraryModalRootContainsTarget
      ) {
        close()
      }
    }
    if (active) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    //eslint-disable-next-line
  }, [ref, active])
  return (
    <StyledPopup className={active ? 'active' : ' '}>
      <div className='popup-container' ref={ref}>
        <div
          onClick={close}
          role='button'
          className='close-container text-red-500'
        >
          <Icon name={LucideIconName.X} className='size-5' />
        </div>
        {content}
      </div>
    </StyledPopup>
  )
}

export default Popup
